export const IMAGE_UPLOADER_STORAGE =
  "https://storage.sumselprov.info/upload";
